import {
  INCLUSION_BANK,
  CONTROL_BANK,
  AFFECTION_BANK,
  THINKING_BANK,
  FLEXIBILITY_BANK
} from "../index";

// Fisher-Yates Shuffle
function shuffle(array) {
  const items = [...array];

  for (let i = items.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [items[i], items[j]] = [items[j], items[i]];
  }

  return items;
}

function pick(bank, count = 4) {
  return shuffle(bank).slice(0, count);
}

export function buildBehaviourAssessment() {

  const assessment = shuffle([
    ...pick(INCLUSION_BANK),
    ...pick(CONTROL_BANK),
    ...pick(AFFECTION_BANK),
    ...pick(THINKING_BANK),
    ...pick(FLEXIBILITY_BANK)
  ]);

  return assessment;
}

